export default __webpack_public_path__ + "static/media/step2-grey.92234249.svg";